import React from "react";
import { MenuButton as ChakraMenuButton } from "@chakra-ui/react";
import { IconButton } from "./icon-button";
export function MenuIconButton({ variant = "ghost", ...props }) {
    return React.createElement(ChakraMenuButton, { as: IconButton, variant: variant, ...props });
}
